export const sortWithNullFirst = (a, b) => {
  if (a === null || b === null) {
    return a === null ? -1 : 1;
  }
  return a - b;
};
